import {
  Box,
  Button,
  Divider,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { useAppStore } from "../../../appStore";
import * as yup from "yup";
import { useFormik } from "formik";
import axios from "axios";
import { useEffect } from "react";
import { api_url } from "../../../apiUtils";
import { SafetyDividerOutlined } from "@mui/icons-material";
import { toast } from "react-toastify";

function Withdraw() {
  const {
    setWithdrawOpen,

    setUserDefaultBalance,
    maximumWithdrawAmount,
    setMaximumWithdrawAmount,
    minimumWithdrawAmount,
    setMinimunWithdrawAmount,
    minimumWalletBalance,
    setMinimumWalletBalance,
    setWalletBalance,
    walletBalance,
    setDepositSent,
  } = useAppStore();

  const setsnackbarMessage = useAppStore((state) => state.setSnackbarMessage);
  const setopenSnackbar = useAppStore((state) => state.setOpenSnackbar);
  const [points, setPoints] = useState(null);
  const [bankDetails, setBankDetails] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const validationSchema = yup.object({
    amount: yup
      .number()
      .required("Points is required")
      .test(
        "custom-test",
        `Points must be less than or equal to ${walletBalance - 100}`,
        function (value) {
          // Add your custom validation logic here
          return value <= walletBalance - 100;
        }
      )

      .min(
        Number(minimumWithdrawAmount),
        `Points must be greater than or equal to ${minimumWithdrawAmount}`
      )
      .max(
        Number(maximumWithdrawAmount),
        `Points must be lesser than or equal to ${maximumWithdrawAmount}`
      ),
  });

  const getBankDetails = async () => {
    let token = sessionStorage.getItem("accesstoken");
    try {
      const response = await axios.get(`${api_url}user/get-bank-details`, {
        headers: {
          accesstoken: token,
        },
      });
      let data = response.data;
      if (data.status === "success" && data.bankDetails) {
        setBankDetails(data.bankDetails); // Store bank details
      } else {
        setBankDetails(null); // No bank details available
      }
    } catch (error) {
      console.error("Failed to fetch bank details", error);
    }
  };

  const getWalletSettings = () => {
    let token = sessionStorage.getItem("accesstoken");
    let result = axios
      .get(`${api_url}wallet/get-common-wallet-settings`, {
        headers: {
          accesstoken: token,
        },
      })
      .then(function (response) {
        let data = response.data;
        console.log(data);
        if (data.status === "success") {
          setUserDefaultBalance(data.getWalletSettings[0].userDefaultBalance);
          setMaximumWithdrawAmount(
            data.getWalletSettings[0].maximumWithdrawAmount
          );
          setMinimunWithdrawAmount(
            data.getWalletSettings[0].minimumWithdrawAmount
          );
          setMinimumWalletBalance(
            +data.getWalletSettings[0].minimumWalletBalance
          );
        }
      });
  };

  useEffect(() => {
    getWalletSettings();
    getBankDetails();
  }, []);

  const formik = useFormik({
    initialValues: {
      amount: "",
    },
    validationSchema: validationSchema,

    onSubmit: (values, { resetForm }) => {
      if (!bankDetails) {
        // If no bank details, show an error and prevent submission
        toast.error("Please add bank details to withdraw.");
        return;
      }

      let updatedBalance = walletBalance - values.amount;
      setWalletBalance(updatedBalance);
      if (isSubmitting) return; // Prevent multiple clicks

      setIsSubmitting(true); // Disable button after first click

      // Perform login logic here using 'values.mobileNumber' and 'values.password'
      let token = sessionStorage.getItem("accesstoken");
      let result = axios
        .post(`${api_url}wallet/withdraw`, values, {
          headers: {
            accesstoken: token,
          },
        })
        .then(function (response) {
          let data = response.data;

          if (data.status === "success") {
            setDepositSent(true);
            toast.success("Request sent successfully");
            setWithdrawOpen(false);
          }
        });
      setIsSubmitting(false); // Re-enable button after request completes
      // Reset the form fields after successful submission
      resetForm();
      // Reset the form fields after successful login
    },
  });
  // const handleAmountChange = (event) => {
  //   setResponseError("");
  //   const inputAmount = event.target.value;
  //   if (inputAmount === "") {
  //     formik.handleChange(event);
  //   } else {
  //     formik.setFieldValue("amount", inputAmount);
  //     // Check if the entered amount exceeds available points and set an error if needed
  //     if (inputAmount > maximumWithdrawAmount) {
  //       formik.setFieldError("amount", "error");
  //     } else if (inputAmount > (points ? points.balance : 0)) {
  //       formik.setFieldError("amount", "Amount exceeds available points");
  //     }
  //   }
  // };
  const handleAmountChange = (event) => {
    const inputAmount = event.target.value;
    if (inputAmount === "") {
      formik.handleChange(event);
    } else {
      formik.setFieldValue("amount", inputAmount);
    }
  };

  let tokenStr = sessionStorage.getItem("accesstoken");

  const getWalletPoints = async () => {
    const response = await axios.get(`${api_url}wallet/balance`, {
      headers: { accesstoken: tokenStr },
    });
    const request = response.data.walletPoint;

    setPoints(request);
    return response.data;
  };

  useEffect(() => {
    getWalletPoints();
  }, []);

  return (
    <>
      <Box sx={{ textAlign: "center" }} mb={1}>
        <Typography variant="h5">Withdraw Amount </Typography>
        <Typography variant="caption" sx={{ color: "#bdbdbd" }}>
          Send request to withdraw point's from your wallet
        </Typography>
      </Box>
      <Box sx={{ border: "1px dashed #bdbdbd" }} />

      <Box height={10} />

      <Grid container mt={2}>
        <Grid item xs={9} sx={{ display: "flex", alignItems: "center" }}>
          <Typography sx={{ color: "#AFAFAF" }}>
            {" "}
            Maximum withdraw amount :
          </Typography>
        </Grid>
        <Grid item xs={3}>
          <Typography>{maximumWithdrawAmount}</Typography>
        </Grid>
      </Grid>
      <Grid container mt={2}>
        <Grid item xs={9} sx={{ display: "flex", alignItems: "center" }}>
          <Typography sx={{ color: "#AFAFAF" }}>
            {" "}
            Minimum withdraw amount :
          </Typography>
        </Grid>
        <Grid item xs={3}>
          <Typography>{minimumWithdrawAmount}</Typography>
        </Grid>
      </Grid>
      <Grid container mt={3}>
        <Grid item xs={9} sx={{ display: "flex", alignItems: "center" }}>
          <Typography sx={{ color: "#AFAFAF" }}>
            {" "}
            Minimum wallet balance :
          </Typography>
        </Grid>
        <Grid item xs={3}>
          <Typography>{minimumWalletBalance}</Typography>
        </Grid>
      </Grid>

      <Grid container mt={3}>
        <Grid item xs={6} sx={{ display: "flex", alignItems: "center" }}>
          <Typography>Available Points :</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography sx={{ fontWeight: "bold", color: "red" }}>
            {Number(points?.balance).toFixed(2)}
          </Typography>
        </Grid>
      </Grid>
      <Grid container mt={3}>
        <Grid item xs={6} sx={{ display: "flex", alignItems: "center" }}>
          <Typography>Enter Withdraw Points :</Typography>
        </Grid>
        <Grid item xs={6}>
          <TextField
            size="small"
            id="amount"
            name="amount"
            error={formik.touched.amount && formik.errors.amount}
            helperText={formik.touched.amount && formik.errors.amount}
            value={formik.values.amount}
            onChange={handleAmountChange}
            onBlur={formik.handleBlur}
          />
        </Grid>
      </Grid>
      <Box sx={{ border: "1px dashed #e0e0e0", mt: 2 }} />
      <Box height={20} />

      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <Box>
          <Button
            fullWidth
            sx={{
              textTransform: "capitalize",
              backgroundColor: "#1e2466",
              height: "100%",
              // fontWeight: "bold",
              letterSpacing: 0.5,
            }}
            variant="contained"
            onClick={formik.handleSubmit}
            disabled={isSubmitting} // Disable button when submitting
          >
            {isSubmitting ? "requesting..." : "Withdraw Request"}
          </Button>
        </Box>
        <Box mt={1}>
          <Button
            fullWidth
            variant="outlined"
            color="error"
            onClick={() => {
              setWithdrawOpen(false);
            }}
            sx={{
              textTransform: "capitalize",
            }}
          >
            Cancel
          </Button>
        </Box>
      </Box>
    </>
  );
}

export default Withdraw;
